/**
import { logger } from "@/utils/logger";
 * Recently Viewed Listings - localStorage utility
 * Stores up to 12 recently viewed listings
 */

const STORAGE_KEY = 'breedling_recently_viewed';
const MAX_ITEMS = 12;

export const recentlyViewedUtils = {
  /**
   * Get all recently viewed listings
   * @returns {Array} Array of listing objects
   */
  getAll: () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      logger.error('Error reading recently viewed:', e);
      return [];
    }
  },

  /**
   * Add a listing to recently viewed
   * @param {Object} listing - The listing object to add
   */
  add: (listing) => {
    if (!listing?.listing_id) return;
    
    try {
      const items = recentlyViewedUtils.getAll();
      
      // Remove if already exists (to move to front)
      const filtered = items.filter(item => item.listing_id !== listing.listing_id);
      
      // Create minimal listing object to store
      const minimalListing = {
        listing_id: listing.listing_id,
        title: listing.title,
        price: listing.price,
        species: listing.species,
        breed: listing.breed,
        listing_type: listing.listing_type,
        photos: listing.photos?.slice(0, 1) || [],
        location_city: listing.location_city,
        location_state: listing.location_state,
        breeder_name: listing.breeder_name,
        in_season: listing.in_season,
        breeding_grade: listing.breeding_grade,
        viewed_at: new Date().toISOString()
      };
      
      // Add to front
      const updated = [minimalListing, ...filtered].slice(0, MAX_ITEMS);
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (e) {
      logger.error('Error saving recently viewed:', e);
    }
  },

  /**
   * Remove a listing from recently viewed
   * @param {string} listingId - The listing ID to remove
   */
  remove: (listingId) => {
    try {
      const items = recentlyViewedUtils.getAll();
      const filtered = items.filter(item => item.listing_id !== listingId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch (e) {
      logger.error('Error removing recently viewed:', e);
    }
  },

  /**
   * Clear all recently viewed listings
   */
  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      logger.error('Error clearing recently viewed:', e);
    }
  }
};
